import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'tools/i18n';
import useApplicationStore from '@services/stores/ApplicationStore';
import { Close } from '@material-ui/icons';
import theme from '@components/theme';

const useStyles = makeStyles({
    wrapper: {},
    notificationsBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        position: 'fixed',
        top: 0,
        right: 0,
        padding: 10,
        minWidth: 280,
        width: '100%',
        zIndex: 1000,
        [theme.breakpoints.down('sm')]: {
            left: 0,
        },
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            maxWidth: 380,
        },
    },
    notify: {
        position: 'relative',
        width: '100%',
        borderRadius: 4,
        background: 'white',
        padding: 18,
        boxShadow: '1px 1px 4px rgba(0, 0, 0, 0.1)',
        transform: 'translateX(0)',
        animation: `$fadeIn 0.2s ease-in-out forwards`,
    },
    closeButton: {
        position: 'absolute',
        top: 9,
        right: 9,
        cursor: 'pointer',
    },
    message: {
        marginBottom: 10,
    },
    removing: {
        opacity: 0,
        animation: `$fadeOut 0.2s ease-in-out forwards`,
    },
    // Keyframes for fade-in
    '@keyframes fadeIn': {
        '0%': { opacity: 0, transform: 'translateX(100px)' },
        '100%': { opacity: 1, transform: 'translateX(0)' },
    },
    // Keyframes for fade-out
    '@keyframes fadeOut': {
        '0%': { opacity: 1, transform: 'translateX(0)' },
        '100%': { opacity: 0, transform: 'translateX(100px)' },
    },
}, { name: 'NotifyToaster' });

export default function NotifyToaster() {
    const classes = useStyles();
    const { t } = useTranslation();
    const notifications = useApplicationStore((state) => state.notifications);

    function renderSubItems(notify) {
        if (notify.components) {
            return <>
                {notify.components}
            </>;
        }

        return null;
    }

    function renderItems() {
        return notifications.map((notify) => {
            const css = [
                classes.notify,
            ];

            if (notify.removing) {
                css.push(classes.removing);
            }

            let title = null;
            if (notify?.title) {
                title = <div className={classes.title}>
                    <strong>{t(notify?.title)}</strong>
                </div>;
            }

            let message = null;
            if (notify?.message) {
                message = <div className={classes.message}>
                    {t(notify?.message)}
                </div>;
            }

            return <div
                key={notify.id}
                className={css.join(' ')}
                onMouseEnter={() => notify.onMouseEnter()}
                onMouseLeave={() => notify.onMouseLeave()}
            >
                <Close className={classes.closeButton} onClick={notify.close}></Close>
                {title}
                {message}
                {renderSubItems(notify)}
            </div>;
        });
    }

    return (
        <div className={classes.wrapper}>
            <section className={classes.notificationsBox}>
                {renderItems()}
            </section>
        </div>
    );
}
